import React from 'react';

// Same spinner the seat-class refresh layer always used
export const SeatSpinner = ({ size = 22 }) => (
    <svg width={size} height={size} viewBox="0 0 50 50" className="seat-loading-spinner" aria-hidden="true">
        <circle cx="25" cy="25" r="20" stroke="#888" strokeWidth="4" fill="none" strokeDasharray="31.4 31.4" strokeLinecap="round">
            <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite" />
        </circle>
    </svg>
);

export const SeatRefreshIcon = () => (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" className="seat-refresh-svg" aria-hidden="true">
        <path d="M4 4v5h5" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2.5 10a7.5 7.5 0 1 1 2.2 5.3" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// Shown in a card's collapsed footer while its train legs' availability is loading,
// instead of a premature "Seats not available"
const SeatCheckingStatus = ({ label = 'Checking seats…' }) => (
    <div
        className="seat-status-container"
        role="status"
        aria-live="polite"
        style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
    >
        <svg width="18" height="18" viewBox="0 0 50 50" aria-hidden="true" style={{ flexShrink: 0 }}>
            <circle cx="25" cy="25" r="20" stroke="#94A3B8" strokeWidth="5" fill="none" strokeDasharray="31.4 31.4" strokeLinecap="round">
                <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite" />
            </circle>
        </svg>
        <span style={{ fontSize: '14px', fontWeight: 600, color: '#64748B', fontFamily: "'Inter', sans-serif" }}>
            {label}
        </span>
    </div>
);

// Shown next to the real status while other classes of a train are still being
// checked, so the status can still change (e.g. not available -> available in SL)
export const SeatRefiningHint = () => (
    <span
        role="status"
        aria-live="polite"
        title="Checking other seat classes"
        style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', fontSize: '12px', fontWeight: 500, color: '#94A3B8', fontFamily: "'Inter', sans-serif", whiteSpace: 'nowrap' }}
    >
        <svg width="12" height="12" viewBox="0 0 50 50" aria-hidden="true" style={{ flexShrink: 0 }}>
            <circle cx="25" cy="25" r="20" stroke="#94A3B8" strokeWidth="6" fill="none" strokeDasharray="31.4 31.4" strokeLinecap="round">
                <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite" />
            </circle>
        </svg>
        checking other classes
    </span>
);

export default SeatCheckingStatus;
